import { PropsWithChildren } from 'react';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import { CardActionProps } from './CardAction.types';

import styles from './CardAction.module.css';

export const CardAction = ({ icon, title, onClick }: PropsWithChildren<CardActionProps>) => {
  const Icon = icon;
  return (
    <Button variant={ButtonVariants.Text} type="button" className={styles.cardAction} onClick={onClick}>
      <Icon size={24} />
      {title}
    </Button>
  );
};
